import WaysToHelpItem from './item';
import type { WaysToHelpContentItem } from '@jlg-website/database/types';
import type { EmblaViewportRefType } from 'embla-carousel-react';

type WaysToHelpServerProps = {
  items: WaysToHelpContentItem[];
  emblaRef?: EmblaViewportRefType;
};

// Mirrors Embla's align:'center' startIndex:1 formula so the server position
// and the hydrated Embla position are identical (no layout shift).
// Mobile  (slide=85vw,  gap=1rem): 50vw - 1.5×85vw  - 1rem = -77.5vw - 1rem
// Desktop (slide=910px, gap=1rem): 50vw - 1.5×910px - 1rem = 50vw - 1365px - 1rem
export function WaysToHelpServer({ items, emblaRef }: WaysToHelpServerProps) {
  return (
    <div className="overflow-hidden" ref={emblaRef}>
      <div
        className="flex gap-4 [--carousel-x:calc(-77.5vw_-_1rem)] @lg:[--carousel-x:calc(50vw_-_1365px_-_1rem)]"
        style={{ transform: 'translate3d(var(--carousel-x), 0px, 0px)' }}
      >
        {items.map((item, i) => (
          <WaysToHelpItem key={i} {...item} />
        ))}
      </div>
    </div>
  );
}
